import { IntegrationCreatePanelController } from '../controller/IntegrationCreatePanelController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { License } from '../../integrationsGrid/types';

export class IntegrationCreatePanelWebComponent extends BaseWebComponentElement {
  public controller!: IntegrationCreatePanelController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: IntegrationCreatePanelController,
    });
  }

  set licenses(licenses: Array<License>) {
    this.setAttribute('data-licenses', JSON.stringify(licenses));
  }

  get licenses() {
    const value = this.getAttribute('data-licenses');
    return value ? JSON.parse(value) : [];
  }

  public initWebcomponent() {
    this.controller.addNewIntegration();
  }
}
